module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "lis01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('h2', {
    staticClass: "chaptertitle"
  }, [_vm._v("List of Illustrations")])]), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/part01#fig1"
    }
  }, [_vm._v("Fig. 1. Filtering reality")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#fig2"
    }
  }, [_vm._v("Fig. 2. Unity in duality")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01#fig3"
    }
  }, [_vm._v("Fig. 3. Horoscope: Gitte M.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap02#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4. Horoscope: Jesper D.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap02#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 5. Horoscope: Anthony")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6. Horoscope: Janne S.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 7. An astrological model of sense filters")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 8. Horoscope: Gitte D.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 9. Horoscope: Gunnar B.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 10. Horoscope: Birgit K.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 11. Horoscope: Lene V.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 12. Evoking sensory experience")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 13. Dynamics of resourceful energy state")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 14. Horoscope: Hanne S.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap04#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig.15. Manifestation of Sun energy")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap05#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig.16. Manifestation of Moon energy")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 17. Manifestation of Mercury energy")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 18. Manifestation of Venus energy")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19. Manifestation of Mars energy")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 20. Jupiter-Saturn conjunctions 1900-2020")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chap09#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 21. Jupiter-Uranus conjunctions 1940-2010")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 22. Jupiter-Neptune conjunctions 1940-2010")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23. Jupiter-Pluto conjunctions 1940-2010")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 24. Saturn-Uranus conjunctions 1850-2050")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 25. Saturn-Neptune conjunctions 1900-2020")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 26. Saturn-Pluto conjunctions 1900-2020")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 27. Uranus-Neptune conjunctions 1600-2000")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#fig28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 28 Uranus-Pluto conjunctions 1600-2000")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 29. Neptune-Pluto conjunctions 1200-2000")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 30. Charlotte D.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 31. Two consultations")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 32. Parallels between past and present")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 33. Horoscope: Stan")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 34. Angles for reframing")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#fig35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 35. Horoscope: Miranda")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#fig36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 36. Decisions and consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#fig37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 37. Past and future: the interplay between Jupiter and Saturn")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#fig38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 38. Horoscope: Marianne G.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#fig39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 39. Sensory storage coordinates")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#fig40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 40. Horoscope: Lene V.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#fig41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 41. Horoscope: Anette G.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#fig42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig 42. Planetary metaphors")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#fig43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 43. Horoscope: Johan")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#fig44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 44. Horoscope: Marie")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09586056","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list_of_illustrations.vue
// module id = 66
// module chunks = 0